import { createTRPCReact } from "@trpc/react-query";
import { httpBatchLink } from "@trpc/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { AppRouter } from "../../api/router";

export const trpc = createTRPCReact<AppRouter>();

const API_URL = import.meta.env.VITE_API_URL || "api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30000,
    },
  },
});

const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: `${API_URL}/trpc/index.php`,
      headers() {
        const token = localStorage.getItem("rb_api_token");
        return token ? { Authorization: `Bearer ${token}` } : {};
      },
      async fetch(input, init) {
        const token = localStorage.getItem("rb_api_token");
        let body = init?.body;
        // Inject __token into body for shared hosting where Authorization header is stripped
        if (body && token && typeof body === 'string') {
          try {
            const batch = JSON.parse(body);
            if (Array.isArray(batch)) {
              batch.forEach((req: any) => {
                if (req.input && typeof req.input === 'object' && !Array.isArray(req.input)) {
                  req.input.__token = token;
                }
              });
              body = JSON.stringify(batch);
            }
          } catch {
            // ignore parse errors, send original body
          }
        }
        return fetch(input, {
          ...(init ?? {}),
          body,
          credentials: "include",
        });
      },
    }),
  ],
});

export function TRPCProvider({ children }: { children: React.ReactNode }) {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
